import { BaseEntity } from "./BaseEntity";

export class QrcodeEntity extends BaseEntity {
	constructor() {
		super();
		this.entityName = "URL QRCode";
		this.pageTitle = "URL QRCode";
		this.APIRoute = "Resources/QRCode";
		this.baseEndPoint = "qrcode";
		this.endpoints = {
			list: `${this.baseEndPoint}`,
			create: `${this.baseEndPoint}`,
			get: `${this.baseEndPoint}/:id`,
			delete: `${this.baseEndPoint}/:id`,
			activate: `${this.baseEndPoint}/:id/activate`,
			deactivate: `${this.baseEndPoint}/:id/deactivate`
		};

		this.fields = [
			{ key: 'id', label: 'user.fields.id', type: 'text', visible: false, editable: false, orderBy: false, path: 'id' },
			{ key: 'name', label: 'common.labels.name', type: 'text', visible: true, required: true, editable: true, cols: 6, path: 'name' },
			{ key: 'target_url', label: 'URL', type: 'text', visible: true, required: true, editable: true, cols: 6, path: 'target_url', notLength: true },
			{ key: 'description', label: 'common.labels.description', type: 'textarea', visible: true, required: false, editable: true, cols: 12, path: 'description' },
			{ key: 'campaign_id', label: 'Campanha', type: 'select', visible: true, required: false, editable: true, cols: 4, path: 'campaign_id', options: [] },
			{ key: 'category_id', label: 'Categoria', type: 'select', visible: true, required: false, editable: true, cols: 4, path: 'category_id', options: [] },
			{ key: 'logo_id', label: 'Logo', type: 'select', visible: true, required: false, editable: true, cols: 4, path: 'logo_id', options: [] },
			{ key: 'status', label: null, type: 'activeSwitch', visible: true, required: false, editable: true, cols: 12, path: 'status' },
		];

		this.tableColumns = [
			{ key: 'name', label: 'common.labels.name', visible: true, orderBy: true },
			{ key: 'target_url', width:"150px", label: 'URL', visible: true, orderBy: false },
			{ key: 'images', label: 'Imagens', visible: true, orderBy: false },
			{ key: 'status', label: 'common.labels.status', visible: true, orderBy: true },
			{ key: 'actions', label: 'common.labels.actions', visible: true, orderBy: false },
		];

		this.pages = {
			edit: { 
				pageTitle: 'Editar URL',
				pathI18n: `components.qrcode.index.quickAccess/URLs`,  
				route: ['/qrcode', '/qrcode/urls', '/qrcode/urls/edit/:id'] 
			},
			create: { 
				pageTitle: 'Criar URL', 
				pathI18n: `components.qrcode.index.quickAccess/URLs`, 
				route: ['/qrcode', '/qrcode/urls', '/qrcode/urls/create'] 
			},
			list: {
				pageTitle: 'URLs', 
				pathI18n: `components.qrcode.index.quickAccess`,
				route: ['/qrcode', '/qrcode/urls'],
				filters: { quickSearch: { info: 'common.messages.info.searchByName', searchBy: ['name'], type: 'text' } }
			},
		};
	}
}
